<template>
  <div class="global-message-with-dismiss-action-button">
    <p
      class="global-message-with-dismiss-action-button-text"
      v-html="sanitized_message"
    ></p>

    <div class="global-message-with-dismiss-action-button-buttons">
      <el-button type="text" plain @click.stop="handleDismiss">
        {{ dismiss_button_text }}
      </el-button>

      <el-button type="text" plain class="blue" @click="handleClick"
        >{{ action_button_text }}
        <svg-icon icon-class="common-arrow-line-right" />
      </el-button>
    </div>
  </div>
</template>

<script>
import DomPurify from "dompurify";
export default {
  props: [
    "message",
    "action_button_text",
    "dismiss_button_text",
    "on_action_button_click",
    "toast_id",
  ],
  computed: {
    sanitized_message() {
      return DomPurify.sanitize(this.message);
    },
  },
  methods: {
    handleDismiss() {
      this.toast_id && this.$toast.dismiss(this.toast_id);
    },
    handleClick() {
      if (this.on_action_button_click) {
        this.on_action_button_click();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.global-message-with-dismiss-action-button {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &-text {
    color: var(--Black, #1d1d1d);

    /* 400/Regular 12 */
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
    letter-spacing: 0.24px;
  }

  &-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;

    button {
      @include button-size(12px, 0px, max-content, 18px, 100%, false);
    }
  }
}
</style>
